import { viewTypeEnum } from "@/modules/crm/sales/tasks/helper";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  viewType: viewTypeEnum.view_1,
};

export const tasksSlice = createSlice({
  name: "tasks",
  initialState: { ...initialState },

  reducers: {
    setTasksViewTypeToState: (state, action) => {
      state.viewType = action?.payload;
    },
  },
});

export const { setTasksViewTypeToState } = tasksSlice.actions;

export const getTasksViewType = (state) => {
  return state.tasks?.viewType;
};

export default tasksSlice.reducer;
